import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchSupportPlugins = createAsyncThunk(
    'supportPlugins/fetchSupportPlugins',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/support-plugins`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)